import { render, staticRenderFns } from "./CategoryLinks.vue?vue&type=template&id=b7113044"
import script from "./CategoryLinks.vue?vue&type=script&lang=ts"
export * from "./CategoryLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports